export default {
  FETCH_BOND_RENEWAL_REQUEST: 'FETCH_BOND_RENEWAL_REQUEST',
  FETCH_BOND_RENEWAL_SUCCESS: 'FETCH_BOND_RENEWAL_SUCCESS',
  FETCH_BOND_RENEWAL_FAILURE: 'FETCH_BOND_RENEWAL_FAILURE',

  DOWNLOAD_BOND_RENEWAL_REPORT_REQUEST: 'DOWNLOAD_BOND_RENEWAL_REPORT_REQUEST',
  DOWNLOAD_BOND_RENEWAL_REPORT_SUCCESS: 'DOWNLOAD_BOND_RENEWAL_REPORT_SUCCESS',
  DOWNLOAD_BOND_RENEWAL_REPORT_FAILURE: 'DOWNLOAD_BOND_RENEWAL_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/bond-renewal/action-types.js